<div *ngIf="isImage === false;else image">
    <ng-content></ng-content>

    </div>
    <ng-template #image>
      <ng-container *ngIf="lazyLoad===false && isImage === true">
      <img
      [src]="imageUrl"
      />
      </ng-container>
      <ng-container *ngIf="lazyLoad===true && isImage === true">
      <img
      [lazyLoad]="imageUrl"
      />
      </ng-container>

    </ng-template>
    